export const sigtype = [
    { mc_id: '水位', mc_name: '水位' },
    { mc_id: '水压', mc_name: '水压' },
    { mc_id: '电压', mc_name: '电压' },
    { mc_id: '电压A', mc_name: '电压A' },
    { mc_id: '电压B', mc_name: '电压B' },
    { mc_id: '电压C', mc_name: '电压C' },
    { mc_id: '主电', mc_name: '主电' },
    { mc_id: '备电', mc_name: '备电' },
    { mc_id: '流量', mc_name: '流量' },
    { mc_id: '体积', mc_name: '体积' },
    { mc_id: '电流', mc_name: '电流' },
    { mc_id: '电流A', mc_name: '电流A' },
    { mc_id: '电流B', mc_name: '电流B' },
    { mc_id: '电流C', mc_name: '电流C' },
    { mc_id: '温度', mc_name: '温度' },
    { mc_id: '温度A', mc_name: '温度A' },
    { mc_id: '温度B', mc_name: '温度B' },
    { mc_id: '温度C', mc_name: '温度C' },
    { mc_id: '温度D', mc_name: '温度D' },
    { mc_id: '允许禁止', mc_name: '允许禁止' },
    { mc_id: '漏电流', mc_name: '漏电流' },
    { mc_id: '浓度', mc_name: '浓度' },
    { mc_id: '主电源', mc_name: '主电源' },
    { mc_id: '备电源', mc_name: '备电源' },
    // { mc_id: '手动', mc_name: '手动' },
    { mc_id: '手自动', mc_name: '手自动' },
    { mc_id: '启停', mc_name: '启停' },
    // { mc_id: '自动', mc_name: '自动' },
    { mc_id: '输出控制口', mc_name: '输出控制口' },

]
// { mc_id: 'A01', mc_name: 'A01' },
// { mc_id: 'A02', mc_name: 'A02' },
// { mc_id: 'A03', mc_name: 'A03' },
// { mc_id: 'A04', mc_name: 'A04' },


export const buildList = [
    [
        {
            key: 9,
            value: "室内消防系统",
        },
        {
            key: 12,
            value: "自动喷水灭火系统",
        },
        {
            key: 15,
            value: '气体灭火系统'
        },
        {
            key: 18,
            value: '疏散指示标识'
        },



    ],
    [
        {
            key: 21,
            value: '消防电梯'
        },
        {
            key: 24,
            value: '灭火器'
        },
        {
            key: 10,
            value: '室外消火栓系统'
        },
        {
            key: 13,
            value: '泡沫灭火系统'
        },


    ],
    [
        {
            key: 16,
            value: '消防应急照明'
        },
        {
            key: 19,
            value: '火灾自动报警系统'
        },
        {
            key: 22,
            value: '其它灭火系统'
        },
        {
            key: 25,
            value: '防烟排烟系统'
        }
    ]
]

export const port = (function () {
    var arr = []
    for (var i = 1; i <= 24; i++) {
        var obj = { mc_id: i, mc_name: i }
        arr.push(obj)
    }
    return arr
})()

export const SecondPort = (function () {
    var Arr = []
    for (var i = 1; i <= 4; i++) {
        var obj = { mc_id: `A0${i}`, mc_name: `A0${i}` }
        Arr.push(obj)
    }
    return Arr
})()